import { render, staticRenderFns } from "./CogneetivPredictNewsGPTNew.vue?vue&type=template&id=02bfe785&scoped=true&"
import script from "./CogneetivPredictNewsGPTNew.vue?vue&type=script&lang=js&"
export * from "./CogneetivPredictNewsGPTNew.vue?vue&type=script&lang=js&"
import style0 from "./CogneetivPredictNewsGPTNew.vue?vue&type=style&index=0&id=02bfe785&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bfe785",
  null
  
)

export default component.exports